import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { Feature, Point } from 'geojson';

// A circle is stored as a 64-vertex polygon; only four handles are shown.
const createSupplementaryPointsForCircle = (
  geojson: Feature
): Array<Feature<Point>> | null => {
  const { properties, geometry } = geojson;
  if (!properties?.user_isCircle || geometry.type !== 'Polygon') return null;

  const supplementaryPoints: Array<Feature<Point>> = [];
  const vertices = geometry.coordinates[0].slice(0, -1);
  const step = Math.round(vertices.length / 4);
  for (let index = 0; index < vertices.length; index += step) {
    supplementaryPoints.push(
      MapboxDraw.lib.createVertex(
        properties.id,
        vertices[index],
        `0.${index}`,
        false
      )
    );
  }
  return supplementaryPoints;
};

export default createSupplementaryPointsForCircle;
